<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Edit Report Requests
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <template v-if="pageReady">
                                        <div class="grid">
                                            <div class="col-12">
                                                <form ref="observer"  tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                                    <!--[form-content-start]-->
                                                    <div class="grid">
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Customer Id 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <api-data-source   api-path="components_data/customer_id_option_list" >
                                                                        <template v-slot="req">
                                                                            <Dropdown class="w-full" :class="getErrorClass('customer_id')"   :loading="req.loading"   optionLabel="label" optionValue="value" ref="ctrlcustomer_id"  v-model="formData.customer_id" :options="req.response" label="Customer Id"  placeholder="Select a value ..." >
                                                                            </Dropdown> 
                                                                            <small v-if="isFieldValid('customer_id')" class="p-error">{{ getFieldError('customer_id') }}</small> 
                                                                        </template>
                                                                    </api-data-source>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Meter Id 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <api-data-source   api-path="components_data/meter_id_option_list" >
                                                                        <template v-slot="req">
                                                                            <Dropdown class="w-full" :class="getErrorClass('meter_id')"   :loading="req.loading"   optionLabel="label" optionValue="value" ref="ctrlmeter_id"  v-model="formData.meter_id" :options="req.response" label="Meter Id"  placeholder="Select a value ..." >
                                                                            </Dropdown> 
                                                                            <small v-if="isFieldValid('meter_id')" class="p-error">{{ getFieldError('meter_id') }}</small> 
                                                                        </template>
                                                                    </api-data-source>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Report Type 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlreport_type" v-model.trim="formData.report_type"  label="Report Type" type="text" placeholder="Enter Report Type"      
                                                                    class=" w-full" :class="getErrorClass('report_type')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('report_type')" class="p-error">{{ getFieldError('report_type') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Start Date 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <Calendar :showButtonBar="true" class="w-full" :class="getErrorClass('start_date')" dateFormat="yy-mm-dd" v-model="formData.start_date" :showIcon="true"     mask="YYYY-MM-DD" outlined dense      />
                                                                    <small v-if="isFieldValid('start_date')" class="p-error">{{ getFieldError('start_date') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    End Date 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <Calendar :showButtonBar="true" class="w-full" :class="getErrorClass('end_date')" dateFormat="yy-mm-dd" v-model="formData.end_date" :showIcon="true"     mask="YYYY-MM-DD" outlined dense      />
                                                                    <small v-if="isFieldValid('end_date')" class="p-error">{{ getFieldError('end_date') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Status 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlstatus" v-model.trim="formData.status"  label="Status" type="text" placeholder="Enter Status"      
                                                                    class=" w-full" :class="getErrorClass('status')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('status')" class="p-error">{{ getFieldError('status') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Report File Type 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <div class="mb-3">
                                                                        <Uploader :class="getErrorClass('report_file_type')" :auto="true" :fileLimit="1" :maxFileSize="3000000" accept=".jpg,.png,.gif,.jpeg" :multiple="false" style="width:100%" label="Choose files or drop files here" upload-path="fileuploader/upload/report_file_type" v-model="formData.report_file_type"></Uploader>
                                                                    </div>
                                                                    <small v-if="isFieldValid('report_file_type')" class="p-error">{{ getFieldError('report_file_type') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Report File Link 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <div class="mb-3">
                                                                        <Uploader :class="getErrorClass('report_file_link')" :auto="true" :fileLimit="1" :maxFileSize="3000000" accept=".jpg,.png,.gif,.jpeg" :multiple="false" style="width:100%" label="Choose files or drop files here" upload-path="fileuploader/upload/report_file_link" v-model="formData.report_file_link"></Uploader>
                                                                    </div>
                                                                    <small v-if="isFieldValid('report_file_link')" class="p-error">{{ getFieldError('report_file_link') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--[form-content-end]-->
                                                    <div v-if="showSubmitButton" class="text-center my-3">
                                                        <Button type="submit" class=" p-button-rounded" label="Update" icon="pi pi-send" :loading="saving" />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="loading">
                                        <div class="p-3 text-center">
                                            <ProgressSpinner style="width:50px;height:50px" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useEditPage } from '@/composables/editpage.js';
	const props = defineProps({
		id: [String, Number],
		pageName: {
			type: String,
			default: 'report_requests',
		},
		routeName: {
			type: String,
			default: 'report_requestsedit',
		},
		pagePath: {
			type : String,
			default : 'report_requests/edit',
		},
		apiPath: {
			type: String,
			default: 'report_requests/edit',
		},
		submitButtonLabel: {
			type: String,
			default: "Update",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterUpdate: {
			type: String,
			default: "Record updated successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
	});
	const app = useApp();
	const formDefaultValues = Object.assign({
		customer_id: "", 
		meter_id: "", 
		report_type: "", 
		start_date: "", 
		end_date: "", 
		status: "ready", 
		report_file_type: "", 
		report_file_link: "", 
	}, props.pageData);
	const formData = reactive({ ...formDefaultValues });
	function onFormSubmited(response) {
		app.flashMsg(props.msgAfterUpdate);
		if(props.redirect) app.navigateTo(`/report_requests`);
	}
	const rules = computed(() => {
		return {
			customer_id: { numeric },
			meter_id: { numeric },
			report_type: {  },
			start_date: {  },
			end_date: {  },
			status: {  },
			report_file_type: {  },
			report_file_link: {  }
		}
	});
	const v$ = useVuelidate(rules, formData); //form validation
	const page = useEditPage(props, formData, v$, onFormSubmited);
	//page state
	const {
		submitted, // form api submitted state - Boolean
		saving, // form api submiting state - Boolean
		loading, // form data loading state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page computed propties
	const {
		apiUrl, // page current api path
		currentRecord, // current page record  - Object
	} = page.computedProps
	//page methods
	const { 
		load, // get editable form data from api
		submitForm, // submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Edit Report Requests";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
		load();
	});
</script>
<style scoped>
</style>
